/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewRoutingRule } from '../models/new-routing-rule';
import { RoutingRulePartialExcludingProjectIdWorkflowEventIdWorkflowStepFunctionId } from '../models/routing-rule-partial-excluding-project-id-workflow-event-id-workflow-step-function-id';
import { RoutingRuleTemplateRenderDto } from '../models/routing-rule-template-render-dto';
import { RoutingRuleWithRelations } from '../models/routing-rule-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class RoutingRuleControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation routingRuleControllerCount
   */
  static readonly RoutingRuleControllerCountPath = '/routing-rules/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation routingRuleControllerFindById
   */
  static readonly RoutingRuleControllerFindByIdPath = '/routing-rules/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<RoutingRuleWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoutingRuleWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<RoutingRuleWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<RoutingRuleWithRelations>) => r.body as RoutingRuleWithRelations)
    );
  }

  /**
   * Path part for operation routingRuleControllerDeleteById
   */
  static readonly RoutingRuleControllerDeleteByIdPath = '/routing-rules/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<RoutingRuleTemplateRenderDto>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoutingRuleTemplateRenderDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<RoutingRuleTemplateRenderDto> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<RoutingRuleTemplateRenderDto>) => r.body as RoutingRuleTemplateRenderDto)
    );
  }

  /**
   * Path part for operation routingRuleControllerUpdateById
   */
  static readonly RoutingRuleControllerUpdateByIdPath = '/routing-rules/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: RoutingRulePartialExcludingProjectIdWorkflowEventIdWorkflowStepFunctionId
  }): Observable<StrictHttpResponse<RoutingRuleTemplateRenderDto>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoutingRuleTemplateRenderDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: RoutingRulePartialExcludingProjectIdWorkflowEventIdWorkflowStepFunctionId
  }): Observable<RoutingRuleTemplateRenderDto> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<RoutingRuleTemplateRenderDto>) => r.body as RoutingRuleTemplateRenderDto)
    );
  }

  /**
   * Path part for operation routingRuleControllerFind
   */
  static readonly RoutingRuleControllerFindPath = '/routing-rules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<RoutingRuleWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoutingRuleWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<RoutingRuleWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RoutingRuleWithRelations>>) => r.body as Array<RoutingRuleWithRelations>)
    );
  }

  /**
   * Path part for operation routingRuleControllerCreate
   */
  static readonly RoutingRuleControllerCreatePath = '/routing-rules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewRoutingRule
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, RoutingRuleControllerService.RoutingRuleControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewRoutingRule
  }): Observable<any> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
